var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSoda = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M7.80176 18.3333L10.3318 32.6467C10.7984 34.985 12.8501 36.6667 15.2334 36.6667H23.7018C26.0851 36.6667 28.1368 34.985 28.6051 32.6467L31.1351 18.3333H7.80176Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.3318 15C18.0151 15 17.6934 14.91 17.4084 14.72C16.6434 14.21 16.4368 13.175 16.9468 12.4083L22.6234 3.89332C23.5534 2.49999 25.1084 1.66666 26.7834 1.66666H33.3334C34.2534 1.66666 35.0001 2.41332 35.0001 3.33332C35.0001 4.25332 34.2534 4.99999 33.3334 4.99999H26.7834C26.2251 4.99999 25.7068 5.27832 25.3968 5.74166L19.7201 14.2567C19.3984 14.74 18.8701 15 18.3318 15Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 15H30.11C29.1817 12.715 27.675 10.7283 25.7217 9.28001C24.8733 8.65168 23.8317 8.33334 22.7767 8.33334H16.16C15.1033 8.33334 14.0633 8.65168 13.215 9.28001C11.2617 10.7283 9.755 12.715 8.82667 15H6.66667C5.74667 15 5 15.7467 5 16.6667C5 17.5867 5.74667 18.3333 6.66667 18.3333H31.6667C32.5867 18.3333 33.3333 17.5867 33.3333 16.6667C33.3333 15.7467 32.5867 15 31.6667 15Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSoda, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/soda.ca2a9e30.svg";
export { ForwardRef as ReactComponent };